<template>
  <v-card
    class="mx-auto pa-3 overflow-visible mb-7"
    outlined
  >
   <v-list-item>
    <v-list-item-content class="overflow-visible">
      <v-list-item-title class="headline mb-2">
        Theo cuộc gọi
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <chartist
    :data="multipleLine.data"
    :options="multipleLine.options"
    type="Line"
    style="max-height: 300px;"
    class="mt-5 chart-multi chart-personal-call chart-fix"
  />
    <div class="chart d-flex justify-center mt-3 mb-3">
      <div class="chart-content">
        <div class="chart-item">
          <span class="chart-bg c-numberOfCallSuccess"></span>
          <span class="font-weight-bold">Số cuộc gọi thành công</span>
        </div>
        <div class="chart-item">
          <span class="chart-bg c-totalOfCallSuccess"></span>
          <span class="font-weight-bold">Tổng phút gọi thành công</span>
        </div>
        <div class="chart-item">
          <span class="chart-bg c-avgOfCall"></span>
          <span class="font-weight-bold">Trung bình cuộc gọi( phút)</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
  import * as ChartistTooltips from 'chartist-plugin-tooltips';
  import { formatPrice } from '@/helpers/utils'
  export default {
    props: {
      dataChart: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        multipleLine: {
          data: {
            labels: this.dataChart.labels,
            series: this.dataChart.series,
          },
          options: {
            low: 0,
            axisY: {
              onlyInteger: true,
              labelInterpolationFnc: (value) => {
                return formatPrice(value)
              },
            },
            fullWidth: true,
            chartPadding: {
              top: 0,
              right: 40,
              bottom: 0,
              left: 40,
            },
            plugins: [this.$chartist.plugins.tooltip(
              {
                currency: ' ',
                tooltipFnc: function(val1, val2) {
                  if(val1 == 'Số cuộc gọi :') {
                    return val1 + val2 + ' cuộc'
                  }

                  if(val1 == 'Số phút gọi :') {
                    return val1 + val2*10 + ' phút'
                  }
                  return val1 + val2 + ' phút'
                }

              }
            )]
          },
        },
      }
    },
    created() {
    },
    mounted() {
      Bus.$on('staff-data-call-chart', () => {
        this.multipleLine.data.labels = this.dataChart.labels
        this.multipleLine.data.series = this.dataChart.series
      })
    }
  }
</script>

<style lang="scss">
  .c-avgOfCall {
    background: orange;
  }
  .c-numberOfCallSuccess {
    background: deepskyblue;
  }
  .c-totalOfCallSuccess {
    background: lightgreen;
  }

  .chart-personal-call {
    .ct-series-a .ct-line, .ct-series-a .ct-point {
      stroke: #00cae3 !important
    }
    .ct-series-b .ct-line, .ct-series-b .ct-point {
      stroke: lightgreen !important
    }
    .ct-series-c .ct-line, .ct-series-c .ct-point {
      stroke: orange !important
    }
  }

  .chart .chart-content .chart-bg {
    height: 5px;
    width: 30px;
    margin-right: 5px;
  }

</style>
